import { FormControlLabel, styled } from "@mui/material";

export const StyledFormControlLabel = styled(FormControlLabel)`
  margin-right: 0;
  margin-left: 0;
  & .MuiTypography-root {
    padding: 0;
  }
`;
